import { put, takeLatest } from 'redux-saga/effects';
import hanldeException from './../services/handleException';
import { syncOrders, syncOrdersBackground } from './../utils/orders';
import { alertError } from './../services/dialog';

function* sync() {
    try {
        const json = yield syncOrders()
        if (json.data.code !== 10001 && json.data.code !== 10007) {
            if (json.data.message) {
                alertError(json.data.message)
            } else {
                hanldeException(json)
            }
            yield put({ type: 'SYNC_ORDERS_FAILURE', json })
        } else {
            if(json.data.code == 10007){
                syncOrdersBackground()
            }
            yield put({ type: 'SYNC_ORDERS_SUCCESS', json })
        }
    } catch (error) {
        hanldeException(error)
        yield put({ type: 'SYNC_ORDERS_FAILURE', error })
    }
}

export function* syncWatcher() {
    yield takeLatest('SYNC_ORDERS', sync)
}



// WEBPACK FOOTER //
// ./src/sagas/syncOrders.js